import screenfull from 'screenfull';

import agent from 'Utils/agent';
import template from './cameraPlayer.html';

/* @ngInject */
function CameraPlayerController($element, $scope, $timeout) {
  const vm = this;

  const TOUCH_DEVICE_NONTHEATER_MODE_TIMEOUT = 3000;
  let isTouchDevice;
  let theaterModeTimeout;


  vm.overlayCtrls = false;
  vm.theaterMode = false;

  vm.$onInit = init;
  vm.$postLink = $postLink;
  vm.changeStream = changeStream;
  vm.toggleOverlay = toggleOverlay;
  vm.updateVideoStatus = updateVideoStatus;
  vm.togglePlayVideo = togglePlayVideo;
  vm.stopTheaterModeOnMouseover = stopTheaterModeOnMouseover;
  vm.startTheaterModeOnMouseleave = startTheaterModeOnMouseleave;
  vm.theaterModeStopVideo = theaterModeStopVideo;
  vm.toggleFullscreen = toggleFullscreen;
  vm.toggleTheater = toggleTheater;

  function init() {
    vm.theaterMode = !agent.isTouchDevice();
    vm.vidStatus = { playVideo: vm.autoPlayVideo || false };
    vm.videoPlaying = vm.vidStatus.playVideo;
    vm.isMultiView = _.size(vm.camsAndViews?.views) > 1;
  }

  function $postLink() {
    $scope.$on('stopPlayer', () => togglePlayVideo(true));
  }

  function changeStream(stream) {
    vm.activeCameraStream = stream;
  }

  function updateVideoStatus(videoPlaying) {
    if (!videoPlaying && theaterModeTimeout) {
      $timeout.cancel(theaterModeTimeout);
      theaterModeTimeout = null;
    }

    vm.videoPlaying = videoPlaying;
    if (isTouchDevice) {
      if (vm.theaterMode) {
        vm.toggleTheater(false);
      } else if (videoPlaying) {
        theaterModeTimeout = $timeout(() => {
          vm.toggleTheater(true);
        }, TOUCH_DEVICE_NONTHEATER_MODE_TIMEOUT);
      }
    }
  }

  function togglePlayVideo(stop) {
    // reassignment to new object will trigger cameraComponent's onChanges
    vm.vidStatus = stop ? { playVideo: false } : { playVideo: true };
    vm.videoPlaying = vm.vidStatus.playVideo;
  }

  function toggleOverlay(clear) {
    vm.overlayCtrls = clear ? false : !vm.overlayCtrls;
  }

  function enterFullscreen() {
    if (screenfull.isEnabled) {
      screenfull.request($element[0]);
    }
  }
  function exitFullScreen() {
    screenfull.exit();
  }
  function toggleFullscreen($event) {
    $event?.stopPropagation();

    const clickedWithinPlayer = ['controls-container', 'player-frame'].includes($event?.target?.className);
    if (clickedWithinPlayer || !$event) {
      screenfull.isFullscreen ? exitFullScreen() : enterFullscreen();
    }
  }

  function stopTheaterModeOnMouseover() {
    if (!isTouchDevice) {
      vm.theaterMode = false;
    }
  }
  function startTheaterModeOnMouseleave() {
    if (!isTouchDevice || vm.videoPlaying) {
      vm.theaterMode = true;
    }
  }
  function theaterModeStopVideo() {
    if (isTouchDevice && vm.theaterMode) {
      vm.toggleTheater(false);
      theaterModeTimeout = $timeout(() => {
        vm.toggleTheater(true);
      }, TOUCH_DEVICE_NONTHEATER_MODE_TIMEOUT);
      return false;
    }
    return true;
  }
  function toggleTheater(on) {
    vm.theaterMode = on;
  }
}

export default {
  name: 'cameraPlayer',
  template,
  controllerAs: 'CameraPlayerCtrl',
  controller: CameraPlayerController,
  bindings: {
    activeCameraId: '<',
    activeCameraStream: '<',
    camsAndViews: '<?',
    panel: '<',
    settingsControls: '<',
    autoPlayVideo: '<?',
    toggleOverlayAction: '<?',
    liveSettings: '<?',
  }
};
